<template lang="">
  <VContainer style="background-color: white;">
    <v-progress-circular v-if="loading" indeterminate color="primary" ></v-progress-circular>
    <template v-if="!loading">
      <VTextField v-model="from" label="From / 送信元" disabled/>
      <VTextField v-model="to" label="To / 宛先" disabled/>
      <VTextField v-model="subject" label="Subject / 件名"/>
      <VTextarea v-model="body" label="Body / 本文" rows="13"/>
      <Base64FileInput label="Attachments / 添付ファイル" v-model="attachments" multiple counter chips/>
      <div class="text-right mt-5">
        <div class="d-flex flex-wrap justify-space-between ga-3">
          <div class="d-flex ga-3">
            <DatePickerInMenu label="date" v-model="sendLaterDate"/>
            <TimePickerInMenu label="time" v-model="sendLaterTime"/>
            <VBtn @click="sendMailLater" color="primary" width="300px" :disabled="!sendLaterValid" :loading="sendingLater">
              {{sendLaterText}}
            </VBtn>
          </div>
          <VBtn @click="sendMail" color="primary" width="100px" :loading="sending">今すぐ送信</VBtn>
        </div>
        <p v-if="hint" class="my-3 primary--text">{{hint}}</p>
      </div>
    </template>
  </VContainer>
</template>

<script>
import Base64FileInput from "@/components/atoms/filefields/Base64FileInput.vue"
import DatePickerInMenu from "@@/components/molecules/DatePickerInMenu.vue"
import TimePickerInMenu from "@@/components/molecules/TimePickerInMenu.vue"
import { HfMemberSendMailCommandService } from "hfapi"

export default {
  components: {
    Base64FileInput,
    DatePickerInMenu,
    TimePickerInMenu,
  },
  props: {
    // メールの諸々
    defaultTo: { type: Array, default: () => [] },
    defaultFrom: { type: String },
    defaultSubject: { type: String, default: "" },
    defaultBody: { type: String, default: "" },
    defaultAttachments: { type: Array, default: () => [] },
    loading: { type: Boolean, default: false },
    hint: { type: String, default: "" }
    // その他
    // mailTypeName: {type: String}, // イベントをemitするときにつけておく?
  },
  data() {
    return {
      to: this.defaultTo,
      from: this.defaultFrom,
      subject: this.defaultSubject,
      body: this.defaultBody,
      attachments: this.defaultAttachments,
      sending: false,

      sendLaterProgress: false,
      sendLaterDate: null,
      sendLaterTime: null,
    }
  },
  computed: {
    sendLaterDateTime() {
      if (!this.sendLaterDate || !this.sendLaterTime) return null;
      return new Date(this.sendLaterDate + "T" + this.sendLaterTime);
    },
    sendLaterValid() {
      if (!this.sendLaterDateTime) return false;
      if (this.sendLaterDateTime < Date.now()) return false;
      return true;
    },
    sendLaterText() {
      if (!this.sendLaterDateTime) return "予定日時を選択";
      if (this.sendLaterDateTime < Date.now()) return "予定日時が過去になっています";
      return this.sendLaterDateTime.toLocaleString() + "に送信";
    }
  },
  methods: {
    sendMail() {
      this.sending = true
      let params = new HfMemberSendMailCommandService.Params()
      params.mail = {
        subject: this.subject,
        body: this.body,
        to: this.to,
        attachments: this.attachments,
      }
      HfMemberSendMailCommandService.execute(params).then((resp) => {
        this.flash("メールの送信に成功しました", "success")
        this.$emit("sent", resp)
      }).catch(e => {
        this.flash("メールの送信に失敗しました\n" + e.message, "error")
        this.$emit("sendError", e)
      }).finally(() => {
        this.sending = false
      })
    },
    sendMailLater() {
      this.sendingLater = true
      let params = new HfMemberSendMailCommandService.Params()
      params.mail = {
        subject: this.subject,
        body: this.body,
        to: this.to,
        attachments: this.attachments,
      }
      params.time = this.sendLaterDateTime.toISOString()

      HfMemberSendMailCommandService.execute(params).then((resp) => {
        this.flash("メールの送信予定の保存に成功しました", "success")
        this.$emit("sent", resp)
      }).catch(e => {
        this.flash("メールの送信予定の保存に失敗しました\n" + e.message, "error")
        this.$emit("sendError", e)
      }).finally(() => {
        this.sendingLater = false
      })
    },
    setDefault() {
      this.to = this.defaultTo
      this.from = this.defaultFrom
      this.subject = this.defaultSubject
      this.body = this.defaultBody
      this.attachments = this.defaultAttachments
    },
  },
  watch: {
    loading(newValue) {
      // 読み込み終了時にdefault値を再度いれる
      if (newValue == false) { this.setDefault() }
    }
  },
}
</script>
<style lang="">

</style>
